declare const window:any;
export default function(){
    //如果不能访问到navigator 或者 window，则是运行环境有意屏蔽该对象，一般而言只有私有运行环境才会产生此问题，常见于手机环境下，如微信等
    if(typeof(window.navigator) == 'undefined' || typeof(window) == 'undefined'){
        return {
            browserVersion: 'unknown',
            browserSystem: 'moblie',
        }
    }
    let $ = window.jQuery;
    //首先根据浏览器返回头判定
    let userAgent:any = window.navigator.userAgent.toLowerCase();
    let browserVersion = '';
    let browserSystem = 'pc';
    let uaMatch:any;
    //获取IE版本  return  {IE11,pc}
    if(userAgent.match(/msie ([\d.]+)/) != null){
        //ie6--ie9                
        uaMatch = userAgent.match(/msie ([\d.]+)/);
        browserVersion = 'IE' + uaMatch[1];
    }else if(userAgent.match(/(trident)\/([\w.]+)/)){
        //ie8--ie11   
        uaMatch = userAgent.match(/trident\/([\w.]+)/);
        switch(uaMatch[1]){
            case "4.0":
                browserVersion = "IE8";
                break;
            case "5.0":
                browserVersion = "IE9";
                break;
            case "6.0":
                browserVersion = "IE10";
                break;
            case "7.0":
                browserVersion = "IE11";
                break;
            default:
                return false;
        }
    }
    let bIsIpad = userAgent.match(/ipad/i) == "ipad";
    let bIsIphoneOs = userAgent.match(/iphone os/i) == "iphone os";
    let bIsMidp = userAgent.match(/midp/i) == "midp";
    let bIsUc7 = userAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    let bIsUc = userAgent.match(/ucweb/i) == "ucweb";
    let bIsAndroid = userAgent.match(/android/i) == "android";
    let bIsCE = userAgent.match(/windows ce/i) == "windows ce";
    let bIsWM = userAgent.match(/windows mobile/i) == "windows mobile";
    if(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM){
        browserSystem = 'mobile';
        if(bIsIpad){
            browserVersion = 'ipad';
        }else if (bIsIphoneOs){
            browserVersion = 'iphone';
        }else if (bIsMidp){
            browserVersion = 'midp';
        }else if (bIsUc7){
            browserVersion = 'uc7';
        }else if (bIsUc){
            browserVersion = 'ucweb';
        }else if (bIsAndroid) {
            browserVersion = 'android';
        }else if (bIsCE){
            browserVersion = 'windowsce';
        }else if (bIsWM){
            browserVersion = 'windowsmobile';
        }
    }
    if(window.jQuery(window).width() < 767){
        browserSystem = 'mobile';
    }
    //暂时处理
    if(browserSystem == 'mobile' && window.jQuery(window).width() >= 767 && bIsAndroid == true){
        browserSystem = 'pad';
    }
    return {
        browserVersion: browserVersion,
        browserSystem: browserSystem
    }
}